import React from "react";
import { Route, Routes } from "react-router-dom";
// import { ProtectedRoute } from "../../shared";
import { PLDashboardList } from "./containers/PLDashboardList";

export const PLDashboard = () => {
  return (
    <Routes>
      <Route path="/" element={<PLDashboardList />} />
      {/* <Route element={<ProtectedRoute allowedRoute={["order-view"]} />}>
        <Route path="/details/:id" element={<OrderDetails />} />
      </Route> */}
    </Routes>
  );
};
